import { l } from 'app/blocks/common/codes';
import showDialog from 'app/blocks/common/jsx/dialogModal';
import middlewareWpg from 'app/blocks/middleware/wpg';
import OrdersOAModalError from 'app/pages/orders/oa/modal-error';
import routes from 'app/pages/routes';

function goToSupport() {
    window.location.replace(this.SUPPORT_LINK);
}

export default function (arg) {
    const codes = l('ERROR');
    const { error, correlationId, onRequestEditOrder, returnToInitiate } = arg;
    const refId = (error && error.refId) || '';

    // TODO: use predefined dialog types
    switch (error.code) {
        case 'EXT_ORDER_ECORE_CREDIT_CARD_DECLINED_US': {
            const { code } = error;
            showDialog.modal(function (closeAnd) {
                return {
                    refId,
                    type: OrdersOAModalError,
                    errorMessage: codes[code],
                    onClose: closeAnd(),
                    onEdit: closeAnd(async function () {
                        try {
                            await middlewareWpg.getOpenAccessWPGConfigAndSubmitForm(correlationId);
                        } catch (error2) {
                            showDialog.addErrorMessageDialog(error2, routes.navigateToDashboard);
                        }
                    }),
                };
            });
            break;
        }
        case 'EXT_ORDER_ECORE_CUSTOMER_VAT_ID_VALIDATION_ERROR': {
            const { code } = error;
            showDialog.modal(function (closeAnd) {
                return {
                    refId,
                    type: OrdersOAModalError,
                    errorMessage: codes[code],
                    onClose: closeAnd(),
                    onEdit: closeAnd(() => onRequestEditOrder('vatTax')),
                };
            });
            break;
        }
        case 'EXT_ORDER_ECORE_CUSTOMER_BILLING_ADDRESS_VALIDATION_ERROR': {
            const { code } = error;
            showDialog.modal(function (closeAnd) {
                return {
                    refId,
                    type: OrdersOAModalError,
                    errorMessage: codes[code],
                    onClose: closeAnd(),
                    onEdit: closeAnd(() => onRequestEditOrder('addresses')),
                };
            });
            break;
        }
        case 'EXT_ORDER_ECORE_CUSTOMER_ACCOUNT_ON_HOLD': {
            const { code } = error;
            showDialog.modal(function (closeAnd) {
                return {
                    refId,
                    type: OrdersOAModalError,
                    errorMessage: codes[code],
                    onClose: closeAnd(),
                    onGoSupport: closeAnd(goToSupport.bind(codes)),
                };
            });
            break;
        }
        case 'RISKIFIED_DECLINED': {
            const message = codes[error.code] || error.message || codes.OTHER_ERROR;
            showDialog.modal(function (closeAnd) {
                return {
                    refId,
                    type: OrdersOAModalError,
                    errorMessage: message,
                    closeButtonText: l('BUTTONS.RETURN_TO_INITIATE'),
                    onClose: closeAnd(returnToInitiate),
                    onGoSupport: closeAnd(goToSupport.bind(codes)),
                };
            });
            break;
        }
        default: {
            showDialog.modal(function (closeAnd) {
                const message = codes[error.code] || error.message || codes.OTHER_ERROR;
                return {
                    refId,
                    type: OrdersOAModalError,
                    errorMessage: message,
                    onClose: closeAnd(),
                };
            });
            break;
        }
    }
}
